import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import API from '../services/api';

export default function ProyectoNuevo() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clienteInicial = searchParams.get('cliente') || '';
  const [form, setForm] = useState({ nombre: '', cliente: clienteInicial, descripcion: '', estado: 'activo', fecha_inicio: '', fecha_fin: '', presupuesto: '', precio_hora_venta: '', referencia: '' });
  const [clientes, setClientes] = useState([]);
  const [sugerencias, setSugerencias] = useState([]);
  const [mostrarDrop, setMostrarDrop] = useState(false);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    API.get('/clientes').then(res => setClientes(res.data)).catch(() => {});
  }, []);

  const buscarCliente = (val) => {
    setForm(f => ({...f, cliente: val}));
    if (val.length > 0) {
      const filtrados = clientes.filter(c => c.nombre.toLowerCase().includes(val.toLowerCase())).slice(0, 5);
      setSugerencias(filtrados);
      setMostrarDrop(true);
    } else {
      setSugerencias([]);
      setMostrarDrop(false);
    }
  };

  const crearClienteNuevo = async () => {
    try {
      await API.post('/clientes', { nombre: form.cliente });
      const res = await API.get('/clientes');
      setClientes(res.data);
      setMostrarDrop(false);
    } catch(e) {}
  };

  const guardar = async () => {
    setError('');
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    setGuardando(true);
    try {
      const res = await API.post('/proyectos', {
        nombre: form.nombre,
        referencia: form.referencia || null,
        cliente: form.cliente || null,
        descripcion: form.descripcion || null,
        estado: form.estado,
        fecha_inicio: form.fecha_inicio || null,
        fecha_fin: form.fecha_fin || null,
        presupuesto: form.presupuesto ? parseFloat(form.presupuesto) : null,
        precio_hora_venta: form.precio_hora_venta ? parseFloat(form.precio_hora_venta) : null,
      });
      navigate(`/proyectos/${res.data.id}`);
    } catch(e) {
      setError(e.response?.data?.detail || 'Error al guardar');
      setGuardando(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate('/proyectos')}>← Proyectos</button>
      </div>
      <div style={s.content}>
        <div style={s.card}>
          <div style={s.cardTitle}>Nuevo proyecto</div>
          {error && <div style={s.errorBox}>{error}</div>}
          <div style={s.field}><label style={s.label}>Referencia <span style={{color:'#aaa',fontWeight:400}}>(se genera automáticamente si no pones nada)</span></label><input style={s.input} value={form.referencia} onChange={e => setForm({...form, referencia: e.target.value})} placeholder={`${new Date().getFullYear()}-001`} autoComplete="off" /></div>
          <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre del proyecto" autoFocus autoComplete="off" /></div>
          <div style={{...s.field, position:'relative'}}>
            <label style={s.label}>Cliente</label>
            <input
              style={s.input}
              value={form.cliente}
              onChange={e => buscarCliente(e.target.value)}
              onFocus={() => form.cliente.length > 0 && setMostrarDrop(true)}
              onBlur={() => setTimeout(() => setMostrarDrop(false), 150)}
              placeholder="Busca o escribe el nombre del cliente"
              autoComplete="new-password"
            />
            {mostrarDrop && (
              <div style={s.dropdown}>
                {sugerencias.map(c => (
                  <div key={c.id} style={s.dropdownItem}
                    onMouseDown={() => { setForm({...form, cliente: c.nombre}); setMostrarDrop(false); }}>
                    {c.nombre}
                  </div>
                ))}
                {sugerencias.length === 0 && form.cliente.length > 0 && (
                  <div style={{...s.dropdownItem, color:'#378ADD', fontWeight:500}}
                    onMouseDown={crearClienteNuevo}>
                    + Crear cliente "{form.cliente}"
                  </div>
                )}
              </div>
            )}
          </div>
          <div style={s.field}><label style={s.label}>Descripción</label><textarea style={{...s.input, height:96, resize:'vertical'}} value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})} placeholder="Descripción opcional" /></div>
          <div style={s.field}>
            <label style={s.label}>Estado</label>
            <select style={s.input} value={form.estado} onChange={e => setForm({...form, estado: e.target.value})}>
              <option value="activo">Activo</option>
              <option value="pausado">Pausado</option>
              <option value="cerrado">Cerrado</option>
            </select>
          </div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>Fecha inicio</label><input style={s.input} type="date" value={form.fecha_inicio} onChange={e => setForm({...form, fecha_inicio: e.target.value})} /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Fecha fin</label><input style={s.input} type="date" value={form.fecha_fin} onChange={e => setForm({...form, fecha_fin: e.target.value})} /></div>
          </div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>Presupuesto (€)</label><input style={s.input} type="number" value={form.presupuesto} onChange={e => setForm({...form, presupuesto: e.target.value})} placeholder="0" /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Precio hora venta (€)</label><input style={s.input} type="number" value={form.precio_hora_venta} onChange={e => setForm({...form, precio_hora_venta: e.target.value})} placeholder="0" /></div>
          </div>
          <div style={s.footer}>
            <button style={s.btnSecondary} onClick={() => navigate('/proyectos')}>Cancelar</button>
            <button style={s.btn} onClick={guardar} disabled={guardando}>{guardando ? 'Guardando...' : 'Crear proyecto'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, maxWidth:600 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24 },
  cardTitle: { fontSize:16, fontWeight:600, color:'#1a1a1a', marginBottom:24 },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  dropdown: { position:'absolute', top:'100%', left:0, right:0, background:'white', border:'0.5px solid #d0d0c8', borderRadius:8, zIndex:100, boxShadow:'0 4px 12px rgba(0,0,0,0.1)', marginTop:2 },
  dropdownItem: { padding:'10px 12px', fontSize:13, cursor:'pointer', borderBottom:'0.5px solid #f0f0ed', color:'#1a1a1a' },
  footer: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24, paddingTop:16, borderTop:'0.5px solid #f0f0ed' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
};
